import { PopoverListButtonItem } from '@aibees/shared/components';
import {
  NotificationActionType as Action,
  NotificationStatus,
} from '@aibees/shared/features/notifications';

export const NOTIFICATION_ACTION_MENU_ITEMS = (
  status?: NotificationStatus
): PopoverListButtonItem[] => [
  {
    label: 'Mark as read',
    key: Action.DELIVER,
    disabled: status !== NotificationStatus.SENT,
  },

  {
    label: 'Delete Permanently',
    key: Action.DELETE,
  },
];
